import './images/banner-bb.png';
import './images/banner-smart.jpg';
// import './images/banner-tech.jpg';
import './index.erb';
import './index.rb';
import 'components/menu';

const init = () => {
  const $segmentButton = $('#newMenu .segment-button');
  const $segmentNewMenu = $('#segmentNewMenu');

  const $headerButtons = $('.nav_header_link_menu:not(div)');
  const $headerSubButtons = $('.nav_header_submenu');

  $segmentButton.off('click').on('click', e => {
    $('#segmentNewMenu').toggle();

    if ($(e.currentTarget).hasClass('active')) {
      $(e.currentTarget).removeClass('active');
    } else {
      $(e.currentTarget).addClass('active');

      window.dataLayer.push({
        event: 'click_menu_header',
        menu_item: $(e.currentTarget).find('span').text()
      });
    }
  });

  $headerButtons.off('click').on('click', () => {
    if (window?.dataLayer) {
      window.dataLayer.push({
        event: 'click_menu_header',
        menu_item: $(this)?.text()
      });
    }
  });

  $headerSubButtons.off('click').on('click', e => {
    if (window?.dataLayer) {
      window.dataLayer.push({
        event: 'click_submenu_header',
        menu_item: ($(e.target)?.text() ?? $(e.target)?.html())?.trim(),
        ...($(e.target).attr('data-parent') && {
          parent_item: $(e.target).attr('data-parent')
        }),
        ...($(e.target).attr('data-category') && {
          category_item: $(e.target).attr('data-category')
        })
      });
    }
  });

  $(document).on('click', e => {
    if (
      !$segmentButton.is(e.target) &&
      $segmentButton.has(e.target).length === 0 &&
      !$segmentNewMenu.is(e.target) &&
      $segmentNewMenu.has(e.target).length === 0
    ) {
      $segmentNewMenu.hide();
      $segmentButton.removeClass('active');
    }
  });
};

document.addEventListener('turbolinks:load', () => init());
init();
